import { AxiosError } from 'axios';
import { isResponsePlainError, PlainResponseError } from 'utils/api/error';
import { PlainResponse } from 'utils/api/error/ResponseError';

enum PEPPER_ERRORS {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
}

const isPepperValidationError = (err: AxiosError<PlainResponse>) => {
  if (isResponsePlainError(err)) {
    const plainError = new PlainResponseError(err);
    const data = plainError.getResponseData();
    return plainError.getErrorMessage() === PEPPER_ERRORS.VALIDATION_ERROR && 'case' in data;
  }
  return false;
};

export default isPepperValidationError;
